<template>
  <div class="padding-h-20">
    <div class="font-27 color-14171B font-bold margin-t-50">Hello!</div>

    <div class="font-27 color-14171B font-bold margin-t-19">Welcome to <span class="color-1477FD">H-</span>Cash.</div>

    <div class="font-16 color-14171B font-bold opacity-90 margin-t-65">Now, Please login with your phone number.</div>

    <div class="bg-F2F4F7 h-55 radius-8 margin-t-41 flex-h flex-v-center">
      <span class="font-18 color-14171B font-bold margin-h-15">+234</span>

      <label class="w-p-100 h-55 flex-h flex-v-center">
        <input class="input-none-border font-bold color-14171B margin-r-15 font-18" type="number" v-model="phone" oninput="if(value.length>11) value=value.slice(0,11)" @input="input_changed()" placeholder="Phone Number" />
      </label>
    </div>

    <div class="margin-t-15 font-bold">
      <van-checkbox v-model="selected_agreement" @change="input_changed()">
        <template #icon="props">
          <div class="flex-h flex-v-center">
            <img class="w-20 h-20 margin-r-10" :src="props.checked ? require('../../assets/select_agreement.png') : require('../../assets/n_select_agreement.png')" />
            <span class="font-14"
              >I have read and agree to the
              <a href="https://www.hcashme.com/agreement/appTermsConditions.html"><span class="color-1477FE">Loan Agreement</span></a>
            </span>
          </div>
        </template>
      </van-checkbox>
    </div>

    <div class="margin-t-56 color-FFFFFF font-bold">
      <van-button color="linear-gradient(to right,#1093FF, #69BBFF)" style="height: 55px; border-radius: 8px; font-size: 19px" :disabled="commitBtnEnable" @click="to_sms_code()" block> SMS OTP </van-button>
    </div>
  </div>
</template>

<script>
import { verifyPhoneRegister, associateCallSale } from '@/api/app'
import { downApp } from '@/utils/app'
import { getQuery } from '@/utils/tools'
export default {
  name: 'login',
  data() {
    return {
      phone: '',
      selected_agreement: false,
      commitBtnEnable: true,
      result: []
    }
  },
  watch: {
    '$route.query': {
      immediate: true, // 立即执行一次回调函数
      handler(newQuery) {
        // 在这里处理地址栏参数的变化
        if (newQuery.oldphone) {
          this.$router.push({
            path: 'sms_code',
            query: {
              phone: newQuery.oldphone
            }
          })
        }
      }
    }
  },
  //   created() {
  //     let oldphone = getQuery('oldphone')
  //     if (oldphone) {
  //       this.$router.push({
  //         path: 'sms_code',
  //         query: {
  //           phone: oldphone
  //         }
  //       })
  //     }
  //   },
  methods: {
    async checkUser(phone) {
      const res = await verifyPhoneRegister({ phone })
      return res
    },
    async to_sms_code() {
      if (!this.phone) {
        this.$toast('Please fill in your phone number')
        return
      }
      let params = {
        phone: this.phone.startsWith('0') ? this.phone.substring(1, this.phone.length) : this.phone,
        type: 1
      }
      this.$showLoading()

      const operatorId = getQuery('operatorId')
      if (operatorId) {
        sessionStorage.setItem('operatorId', operatorId)
        const isOld = await this.checkUser(this.phone)
        if (isOld) {
          associateCallSale({ operatorId, phone: this.phone })
          downApp(this.phone)
          sessionStorage.removeItem('operatorId') //点击后清除
          return
        }
      }

      // this.$request.sendSmsCode(params)
      //     .then(() => {
      //         this.$hideLoading()
      //         this.$toast("send success")
      this.$router.push({
        path: 'sms_code',
        query: {
          phone: params.phone
        }
      })
      // })
      // .catch(() => {
      //     this.$hideLoading()
      // })
    },
    input_changed() {
      this.commitBtnEnable = !this.selected_agreement || this.phone.length < 10 || this.phone.length > 11
    }
  }
}
</script>

<style scoped></style>
